/* Future Form - product page layer (draft theme).
   The sticky section bar (product name, section links, price) was removed
   on request. What remains: price changes animate, and the gallery can be
   browsed with the arrow keys. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var pdp = document.querySelector('.ff-pdp');
    if (!pdp || pdp.dataset.ffxPlus) return;
    pdp.dataset.ffxPlus = '1';

    /* price change: animate the number in the buy panel */
    var mainPrice = pdp.querySelector('.ff-pdp__price');
    if (mainPrice && !reduce && 'MutationObserver' in window) {
      var last = mainPrice.textContent;
      new MutationObserver(function () {
        if (mainPrice.textContent === last) return;
        last = mainPrice.textContent;
        mainPrice.classList.remove('ffx-flash');
        void mainPrice.offsetWidth;
        mainPrice.classList.add('ffx-flash');
      }).observe(mainPrice, { childList: true, characterData: true, subtree: true });
    }

    /* gallery: arrow keys */
    var main = pdp.querySelector('.ff-pdp__main');
    if (main) {
      main.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowLeft' ? 'prev' : e.key === 'ArrowRight' ? 'next' : '';
        if (!dir) return;
        var b = main.querySelector('.ff-gnav--' + dir);
        if (b) { e.preventDefault(); b.click(); }
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
